// extracted by mini-css-extract-plugin
module.exports = {"selection":"AbsenceModalContent_selection__3-6BW"};